import ScreenerFormContainer from './screener_form_container';

const ScreenerForm = ScreenerFormContainer;
export default ScreenerForm;
